import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import logobgremove from "../pages/images/logo/logobgremove.png";
import logotext from "../pages/images/logo/removebgelegance.png";

export default function Header() {
  const navigate = useNavigate();

  return (
    <header
      className="d-flex justify-content-between align-items-center px-3 px-md-4 shadow-sm"
      style={{
        backgroundColor: "#3a0d2e",   // premium cream background
        height: "85px",               // perfect luxury header height
        position: "relative",
        zIndex: 1000
      }}
    >
      {/* Logo + Brand */}
      <div
        className="d-flex align-items-center"
        style={{ cursor: "pointer", gap: "10px" }}
        onClick={() => navigate("/orrbiitelegance")}
      >
        {/* Icon */}
        <img
          src={logobgremove}
          alt="Logo"
          style={{
            width: "70px",
            height: "70px",
            objectFit: "contain"
          }}
        />

        {/* Brand Text Image */}
        <img
          src={logotext}
          alt="Orrbiit Elegance"
          style={{
            height: window.innerWidth < 768 ? "42px" : "64px",
            width: "auto",
            maxWidth: "150px",
            objectFit: "contain"
          }}
        />
      </div>

      {/* Right side blank for now (menu later) */}
      <div></div>
    </header>
  );
}
